/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useState, useMemo, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import useRenameForm from 'asset-actions-lib-forms/rename/hooks/useRenameForm';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_NAME_LENGTH = 255;
export default function CollectedFormRenameDialog({
  onClose,
  crmObject,
  onConfirm
}) {
  const formGuid = useMemo(() => getPropertyValue(crmObject, 'hs_form_id'), [crmObject]);
  const formName = useMemo(() => getPropertyValue(crmObject, 'hs_name'), [crmObject]);
  const [internalFormName, setInternalFormName] = useState(formName);
  const {
    renameForm,
    error,
    loading
  } = useRenameForm();
  const isNameValid = useMemo(() => internalFormName.length > 0 && internalFormName.length < MAX_NAME_LENGTH, [internalFormName.length]);
  const isValid = useMemo(() => !error && isNameValid, [error, isNameValid]);
  const handleRenameForm = useCallback(() => {
    return renameForm({
      formGuid,
      formName: internalFormName
    }).then(() => onConfirm(FORM_ACTION_IDS.RENAME, {
      crmObject,
      newFormName: internalFormName
    }));
  }, [crmObject, formGuid, internalFormName, onConfirm, renameForm]);
  const renderValidationMessage = () => {
    if (!isNameValid) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.renameDialog.errorMessages.INVALID_NAME"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.renameDialog.errorMessages.UNKNOWN"
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "form-rename-dialog",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.renameDialog.heading"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.renameDialog.formName"
        }),
        error: !isValid,
        validationMessage: isValid ? null : renderValidationMessage(),
        children: /*#__PURE__*/_jsx(TextInput, {
          defaultValue: internalFormName,
          onChange: evt => setInternalFormName(evt.target.value)
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(LoadingButton, {
        failed: !!error,
        loading: loading,
        use: "primary",
        onClick: handleRenameForm,
        disabled: !isValid,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.renameDialog.save"
        })
      })
    })]
  });
}